import {useI18n} from 'vue-i18n';
import {MoodLevelDTO} from '@/ts/types/dto/journals-dto';
import moodVeryLow from '@/assets/img/mood_very_low.svg';
import moodLow from '@/assets/img/mood_low.svg';
import moodOk from '@/assets/img/mood_ok.svg';
import moodGood from '@/assets/img/mood_good.svg';
import moodGreat from '@/assets/img/mood_great.svg';

interface MoodLevelComposable {
  getMoodLevelLabel(level: MoodLevelDTO): string;
  getMoodLevelImage(level: MoodLevelDTO): string;
}

/** Provides helpers to get the translated label and SVG image for a given mood level */
export function useMoodLevel(): MoodLevelComposable {
  const {t} = useI18n();

  function getMoodLevelLabel(level: MoodLevelDTO): string {
    return t(`mood_level_${level}`);
  }

  function getMoodLevelImage(level: MoodLevelDTO): string {
    switch (level) {
      case MoodLevelDTO.VERY_LOW: return moodVeryLow;
      case MoodLevelDTO.LOW: return moodLow;
      case MoodLevelDTO.OKAY: return moodOk;
      case MoodLevelDTO.GOOD: return moodGood;
      case MoodLevelDTO.GREAT: return moodGreat;
      default: return '';
    }
  }

  return {getMoodLevelLabel, getMoodLevelImage};
}
